import React, { useCallback, useState } from "react";
import { Chip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import EmailListModal from "../campaign-report-detail/EmailListModal";

const BlueChip = styled(Chip)(() => ({
  background: "var(--primary-tint)",
  color: "var(--primary-base)",
}));

function CustomerList({
  label = "",
  contactNo = "",
  className = "",
}: {
  label?: string;
  contactNo?: string | number;
  className?: string;
}) {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <BlueChip
        style={{
          background: "var(--primary-tint)",
          color: "var(--primary-base)",
          borderRadius: "var(--radius-control)",
          // whiteSpace: "nowrap",
          width: "auto",
        }}
        onClick={handleOpen}
        label={
          <Typography
            variant="caption"
            style={{
              background: "var(--primary-tint)",
              color: "var(--primary-base)",
              borderRadius: "var(--radius-control)",
              // whiteSpace: "nowrap",
              width: "auto",
            }}
            className={`px-2 ${className}`}
          >
            <span className="fw-sb">{label}</span>
            <span className="ml-1">({`${contactNo} contacts`})</span>
          </Typography>
        }
      />

      {open && (
        <EmailListModal
          open={open}
          onClose={handleClose}
          customerListName={`${label} ${contactNo} contacts`}
          heading="Customer List"
        />
      )}
    </>
  );
}

export default CustomerList;
